import {fromJS} from 'immutable';

import {
  MODIFY_CART_ATTRIBUTE,
  REMOVE_CART_ATTRIBUTE,
  LOAD_CART,
  CLEAR_CART
} from '../actions/cartActions';

// Initial state
const initialState = fromJS({loading: false, error: {}, cart: {}});

// Reducer
export default function CartReducer(state = initialState, action = {}) {

  //console.log("cart in reducer........", action);
  switch (action.type) {
    case MODIFY_CART_ATTRIBUTE:
    case REMOVE_CART_ATTRIBUTE:
    case LOAD_CART:

      return state.set('cart', action.payload)
    case CLEAR_CART:
      return state.set('cart', {})
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cartReducer.js